import { concat, equalBytes } from './encoding';
import { randomBytes, sha256 } from './primitives';

const ALPHABET = '0123456789ABCDEFGHJKMNPQRSTVWXYZ';
const PREFIX = 'HTRK1-';

function encodeBase32(bytes: Uint8Array): string {
  let bits = 0; let value = 0; let result = '';
  for (const byte of bytes) {
    value = (value << 8) | byte; bits += 8;
    while (bits >= 5) { result += ALPHABET[(value >>> (bits - 5)) & 31]; bits -= 5; }
  }
  if (bits > 0) result += ALPHABET[(value << (5 - bits)) & 31];
  return result;
}

function decodeBase32(encoded: string): Uint8Array {
  const normalized = encoded.toUpperCase().replace(/O/g, '0').replace(/[IL]/g, '1');
  let bits = 0; let value = 0; const result: number[] = [];
  for (const character of normalized) {
    const index = ALPHABET.indexOf(character); if (index < 0) throw new Error('Ungültiger Recovery-Key.');
    value = (value << 5) | index; bits += 5;
    if (bits >= 8) { result.push((value >>> (bits - 8)) & 255); bits -= 8; }
  }
  return Uint8Array.from(result);
}

export async function generateRecoveryKey(): Promise<string> {
  return formatRecoveryKey(randomBytes(32));
}

export async function formatRecoveryKey(secret: Uint8Array): Promise<string> {
  if (secret.length !== 32) throw new Error('Recovery-Secret muss 32 Byte lang sein.');
  const checksum = (await sha256(secret)).slice(0, 4);
  const encoded = encodeBase32(concat(secret, checksum));
  return PREFIX + encoded.match(/.{1,4}/gu)!.join('-');
}

export async function decodeRecoveryKey(value: string): Promise<Uint8Array> {
  const compact = value.trim().toUpperCase().replace(/-/g, '');
  if (!compact.startsWith('HTRK1')) throw new Error('Der Recovery-Key hat ein unbekanntes Präfix.');
  const bytes = decodeBase32(compact.slice(5));
  if (bytes.length !== 36) throw new Error('Der Recovery-Key hat eine ungültige Länge.');
  const secret = bytes.slice(0, 32); const checksum = (await sha256(secret)).slice(0, 4);
  if (!equalBytes(checksum, bytes.slice(32))) throw new Error('Die Prüfsumme des Recovery-Keys ist falsch.');
  return secret;
}
